// extracted by mini-css-extract-plugin
export default {"cls1":"a02s6ZUhfhmMKCYhDcNG","cls2":"Xze3wU8djAmaMB0BJ9F2 a02s6ZUhfhmMKCYhDcNG"};